module.exports = __webpack_public_path__ + "static/logo-5afab1441725ae87e9b86b2ce0ea17c3.svg";